import {
  CREATE_NEW_RECORD,
  CREATE_NEW_RECORD_SUCCESS,
  CREATE_NEW_RECORD_ERROR,
  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  PANEL_NEW_RECORD_SHOW_CLICK,
  COMMENT_PANEL_SHOW_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
  COMMENT_PANEL_SHOW_CLICK,
  COMMENT_PANEL_HIDE_CLICK,
  EDIT_BUTTON_PRESSED,
  CREATE_BUTTON_PRESSED
} from "../actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  isNewRecordPanelShown: false,
  isNewCommentPanelShown: false,
  recordTypeSelected: EnumRecordTypes.Person,
  loading: false,
  error: "",
  record: {},
  isEditButtonPressed: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_NEW_RECORD:
      return { ...state, loading: true, error: "", person: action.payload.newRecord };
    case CREATE_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", record: action.payload, isNewRecordPanelShown: false };
    case CREATE_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };
    case PANEL_NEW_RECORD_SHOW_HIDE_CLICK:
      return { ...state, loading: false, error: "", isNewRecordPanelShown: !state.isNewRecordPanelShown };
    case COMMENT_PANEL_SHOW_HIDE_CLICK:
      return { ...state, loading: false, error: "", isNewCommentPanelShown: !state.isNewCommentPanelShown };
    case COMMENT_PANEL_SHOW_CLICK:
      return { ...state, loading: false, error: "", isNewCommentPanelShown: true };
    case COMMENT_PANEL_HIDE_CLICK:
      return { ...state, loading: false, error: "", isNewCommentPanelShown: false };
    case PANEL_NEW_RECORD_HIDE_CLICK:
      return { ...state, loading: false, error: "", isNewRecordPanelShown: false };
    case PANEL_NEW_RECORD_SHOW_CLICK:
      return { ...state, loading: false, error: "", isNewRecordPanelShown: true };
    case SET_RECORD_TYPE:
      return { ...state, recordTypeSelected: action.payload.recordTypeSelected };
    case UPDATE_NEW_RECORD_STATE:
      return { ...state, ...action.payload.updatedValues };
    case EDIT_BUTTON_PRESSED:
      return { ...state, isEditButtonPressed: true};
    case CREATE_BUTTON_PRESSED:
      return { ...state, isEditButtonPressed: false};
    default:
      return { ...state };
  }
};
